var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVision = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 11.73C21 10.43 16.93 5 12 5s-9 5.42-9.95 6.72a.48.48 0 0 0 0 .56C3 13.58 7.07 19 12 19s9-5.43 10-6.73a.45.45 0 0 0 0-.54ZM12 17a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm1 3a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
})));
export default SvgVision;